import React, { useState } from "react";
import "./Doughnut.css";
import ldoughnut from "../../images/largefilleddoughnut.jpeg";
import { toast } from "react-toastify";
import { SyncOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { axiosInstance } from "../../config";

const Doughnut = () => {
  const [order, setOrder] = useState({
    pastry: "Cake",
    name: "",
    contact: "",
    quantity: "",
    delivery: "",
    price: 0,
  });

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const doughnuts = [
    { quantity: 4, price: 30 },
    { quantity: 6, price: 45 },
    { quantity: 10, price: 74 },
    { quantity: 15, price: 110 },
  ];
  const HandleSelect = (e) => {
    setOrder({
      ...order,
      quantity: e.target.options[e.target.selectedIndex].text,
      price: e.target.value,
    });
  };
  const handleChange = (e) => {
    setOrder({ ...order, [e.target.name]: e.target.value });
  };

  //
  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const { data } = await axiosInstance.post(`/api/doughnut`, {
        name: order.name,
        contact: order.contact,
        quantity: order.quantity,
        delivery: order.delivery,
        price: order.price,
      });
      toast.success("Order Placed. Screenshot pop-up for payment details");
      setVisible(true);
      setLoading(false);
      console.log(data);
      console.log(order);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data);
      return err;
    }
  };
  console.log(order);
  return (
    <>
      <div className="doughnut-main">
        <div
          className="d-image-main cursor-pointer hover:scale-105 
    transform transition duration-300 ease-out"
        >
          <img
            className="d-image"
            src={ldoughnut}
            alt="large-filled-doughnut"
          />
        </div>
        <div className="d-order-menu">
          {/* <h1 className="d-order-heading">asdfa</h1> */}
          <div className="order-info">
            <div>
              <input
                className="order-input"
                name="name"
                type="text"
                placeholder="Name"
                onChange={handleChange}
              />
            </div>
            <div>
              <input
                className="order-input"
                name="contact"
                type="tel"
                placeholder="Contact"
                onChange={handleChange}
              />
            </div>
            <select className="d-select" onChange={HandleSelect} required>
              <option value="none">-- Order --</option>
              {doughnuts.map((doughnut, index) => (
                <option
                  key={index}
                  name={doughnut.quantity}
                  value={doughnut.price}
                >
                  {doughnut.quantity +
                    " doughnuts for " +
                    doughnut.price +
                    " GHC"}
                </option>
              ))}
            </select>
            <div
              className="
        note"
            >
              <h1>
                <em>
                  Delivery Cost will be charged by the rider,
                  <br />
                  make sure to contact us with your order details and the
                  location you want the order delivered to via whatsapp or call
                </em>
              </h1>
            </div>
            <select
              className="select-option"
              name="delivery"
              onChange={handleChange}
              required
            >
              <option value="">-- Delivery Method --</option>
              <option value="Pickup">Pick Up</option>
              <option value="Delivery">Delivery</option>
            </select>
          </div>
          {/* <div>
         
        </div> */}
          <button
            onClick={onSubmit}
            disabled={!order.name || !order.contact || loading}
          >
            {loading ? <SyncOutlined spin /> : "Order"}
          </button>
        </div>
      </div>
      <Modal
        title="PAYMENT DETAILS"
        centered
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
      >
        {/* order
        <pre>{JSON.stringify(order, null, 5)}</pre> */}
        <div className="modal-main">
          <div className="modal-details">
            <h3 className="m-heading">Oder Details</h3>
            <div className="m-details">
              <h1 className="m-label">Name: </h1>
              <h1 className="m-details">{order.name}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Contact: </h1>
              <h1 className="m-details">{order.contact}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Quantity: </h1>
              <h1 className="m-details">{order.quantity}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Delivery Method: </h1>
              <h1 className="m-details">{order.delivery}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Price: </h1>
              <h1 className="m-details">{order.price}</h1>
            </div>
            {/* <div className="m-details">
              <h1 className="m-label">Size: </h1>
              <h1 className="m-details">{order.size + " pounds"}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Total: </h1>
              <h1 className="m-details">{order.totalPrice + " GHC"}</h1>
            </div> */}
          </div>
          <div className="modal-payment">
            <h1 className="m-label">
              Make payment of {order.price + " GHC"} to{" "}
              <span className="m-number">0553009397 or 0509034660</span>{" "}
            </h1>
            <h1>
              Use your <span className="m-number">Name</span> or{" "}
              <span className="m-number"> Number</span> as Reference
            </h1>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Doughnut;
